import { gql } from '@apollo/client';
import { articleCommonData } from './articleCommonData';

export const getSortedArticlesQuery = gql`
  query getSortedArticles($userId: ID!, $where: ArticleWhereInput, $sortBy: ArticlesOrder, $skip: Int!, $take: Int!) {
    getSortedArticles(where: $where, sortBy: $sortBy, skip: $skip, take: $take) {
      articles {
       ${articleCommonData}
        userRelations(
          where: { relationType: { equals: read }, percentReadTime: { gt: "0.5" }, user: { id: { equals: $userId } } }
        ) {
          id
          percentReadTime
          relationType
        }
      }
      articlesCount
    }
  }
`;
